import dayjs from 'dayjs'
import type { EventDoc, Exclusion } from 'types/api/changes'

import { dateInTimezone, resolveTimezone } from './timezone'

// Native records use UTC-midnight calendar dates; older Google imports use
// occurrence instants. Non-midnight instants must be read in the event zone.
export function exclusionCalendarDate(
  exclusion: Exclusion,
  timeZone = 'UTC'
): string | undefined {
  if (exclusion.Date != null && String(exclusion.Date).trim() !== '') {
    const timestamp = Number(exclusion.Date)
    const date = dayjs.unix(timestamp).utc()
    if (Number.isFinite(timestamp) && date.isValid())
      return date.isSame(date.startOf('day'))
        ? date.format('YYYY-MM-DD')
        : dateInTimezone(timestamp * 1000, timeZone).format('YYYY-MM-DD')
  }
  const parts = exclusion.ExclusionDate?.match(
    /^(\d{4})-?(\d{2})-?(\d{2})(?:T|$)/
  )
  if (!parts) return undefined
  const calendarDate = `${parts[1]}-${parts[2]}-${parts[3]}`
  const date = dayjs.utc(calendarDate)
  return date.isValid() && date.format('YYYY-MM-DD') === calendarDate
    ? calendarDate
    : undefined
}

export function recurrenceExclusionDate(instanceTime: number, event: EventDoc) {
  const date = dateInTimezone(
    instanceTime,
    event.AllDay === '1' ? 'UTC' : resolveTimezone(event.TimeZoneNameID)
  )
  return {
    Date: dayjs.utc(date.format('YYYY-MM-DD')).unix().toString(),
    ExclusionDate: date.format('YYYYMMDDTHHmmss')
  }
}
